<template>
  <div class="sky-deploy-step-view-desktop-info">
    <div class="wsp-display-tb-center backgroud-color-f0fbff color-38a4f5 wsp-padding-left-6" style="height: 48px;">
      注：岗位信息的软件外设确认，可以与客户进行沟通，通过下方的【环境采集工具】采集客户桌面上的软件/外设，提前匹配对应的软件/外设兼容性信息，减少兼容性问题
    </div>
    <div class="desktop-info-item desktop-info-item-post">
      <div class="wsp-group-title" style="width: 100% !important;">
        <div class="wsp-group-title-icon"></div>
        <div class="wsp-group-title-value">岗位桌面配置</div>
        <div class="wsp-group-title-tip">
          <el-button type="primary" @click="addPostByTemplate">从模版添加岗位</el-button>
          <el-button type="primary" @click="addPostByHandel">手动添加岗位</el-button>
        </div>
        <div class="wsp-line-height-28 wsp-padding-left-6">
          客户环境采集可点击右侧工具进行下载（支持Windows7/Windows10/Windows11）
        </div>
        <div class="wsp-line-height-28 sk-link--normal el-icon-download" @click="downloadCollectTool()">
          环境采集工具下载
        </div>
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div v-html="downToolTip" slot="content" class=""></div>
          <i class="el-icon-question wsp-line-height-28 sk-link--normal"></i>
        </el-tooltip>
      </div>
      <div class="wsp-group-content desktop-info-item-content wsp-margin-right-12 ">
        <div
          v-for="(postDesktopItem, index) in postDesktopList"
          :key="index"
          class="desktop-info-item wsp-line-height-24 wsp-border wsp-margin-6 wsp-border-radius-6"
        >
          <div class="desktop-info-item-toolbar">
            <el-tooltip class="item" effect="light" content="删除岗位" placement="left">
              <el-button
                type="text"
                class="el-icon-delete remove-btn color-ec2805"
                @click="removePosition(index)"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="post-desktop-content">
            <div
              class="wsp-width-100 wsp-border-right wsp-border-bottom desktop-post-content wsp-display-flex wsp-line-height-36"
            >
              <div class="wsp-display-flex  wsp-width-35 position-item-arr  wsp-border-right">
                <div
                  class=" item-label backgroud-color-38a4f5 wsp-text-align-center"
                  style="width:150px; border-top-left-radius: 3px;"
                >
                  岗位名称
                </div>
                <div :class="`wsp-width-100 item-value ${postDesktopItem.name ? '' : 'input-validate-not-null'}`">
                  <el-input v-model="postDesktopItem.name" placeholder="请填写岗位名称"></el-input>
                </div>
              </div>
              <div class="wsp-display-flex wsp-width-65 position-item-arr">
                <div class=" item-label backgroud-color-38a4f5 wsp-text-align-center" style="width:150px">岗位说明</div>
                <div class="wsp-width-100 item-value">
                  <el-input v-model="postDesktopItem.description" placeholder="请添加岗位说明"></el-input>
                </div>
              </div>
              <!-- <div class="desktop-post-toolbar">
                <el-button type="text" @click="bindReport(postDesktopItem, index)">绑定岗位采集软件/外设报告</el-button>
              </div> -->
            </div>
            <div class="wsp-width-100 desktop-system-content">
              <div
                v-for="(desktopItem, systemIndex) in postDesktopItem.desktopList"
                :key="systemIndex"
                :class="`${index === 0 ? 'wsp-border-bottom' : ''}`"
              >
                <div class="wsp-display-flex">
                  <div class="wsp-width-10 wsp-border-right desktop-system-index">
                    <div class="wsp-text-align-center wsp-border-bottom wsp-margin-3" v-if="systemIndex === 0">
                      <strong>桌面</strong>
                    </div>
                    <div class="wsp-display-flex-center desktop-system-index-value">
                      <div style="text-align: center">
                        <strong>桌面{{ systemIndex + 1 }}</strong>
                        <div class="wsp-display-flex-center wsp-margin-12">
                          <div style="font-size: 14px;line-height: 32px; width: 40% !important;">
                            数量：
                          </div>
                          <el-input-number
                            style="width: 60% !important;"
                            v-model="desktopItem.desktopNum"
                            :min="1"
                            controls-position="right"
                          ></el-input-number>
                        </div>
                        <!-- <div class="report-name" v-if="desktopItem.reportDetail">
                          <strong>{{ desktopItem.reportDetail.customer }}</strong>
                        </div> -->
                      </div>
                      <el-tooltip
                        class="item"
                        effect="light"
                        v-if="postDesktopItem.desktopList.length > 1"
                        :content="`删除【桌面 ${systemIndex + 1} 】`"
                        placement="left"
                      >
                        <el-button
                          @click="removePositionDesktop(index, systemIndex)"
                          type="text"
                          class="el-icon-delete desktop-system-index-btn remove-btn color-ec2805"
                          v-if="postDesktopItem.desktopList.length > 1"
                        ></el-button>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="wsp-width-25 wsp-border-right desktop-system-setting">
                    <div class="wsp-text-align-center wsp-border-bottom wsp-margin-3" v-if="systemIndex === 0">
                      <strong>系统配置</strong>
                    </div>
                    <div class="wsp-padding-3">
                      <div class="wsp-display-flex setting-attr">
                        <div class="wsp-width-30 wsp-text-align-right">操作系统：</div>
                        <div :class="`wsp-width-60 ${desktopItem.osTypeId ? '' : 'input-validate-not-null'}`">
                          <el-select class="wsp-width-100" v-model="desktopItem.osTypeId" placeholder="请选择">
                            <el-option
                              v-for="(osItem, index) in osTypeList"
                              :key="index"
                              :label="osItem.osType"
                              :value="osItem.id"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div>
                        <div class="wsp-display-flex setting-attr wsp-margin-3">
                          <div class="wsp-width-30 wsp-text-align-right">CPU：</div>
                          <div :class="`wsp-width-60 ${desktopItem.cpuCore ? '' : 'input-validate-not-null'}`">
                            <el-input-number class="wsp-width-100" v-model="desktopItem.cpuCore"></el-input-number>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="wsp-display-flex setting-attr wsp-margin-3">
                          <div class="wsp-width-30 wsp-text-align-right">内存：</div>
                          <div :class="`wsp-width-60 ${desktopItem.memory ? '' : 'input-validate-not-null'}`">
                            <el-input-number class="wsp-width-100" v-model="desktopItem.memory"></el-input-number>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="wsp-display-flex setting-attr wsp-margin-3">
                          <div class="wsp-width-30 wsp-text-align-right">系统盘(C盘)：</div>
                          <div :class="`wsp-width-60 ${desktopItem.cDiskSize ? '' : 'input-validate-not-null'}`">
                            <el-input-number class="wsp-width-100" v-model="desktopItem.cDiskSize"></el-input-number>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="wsp-display-flex setting-attr wsp-margin-3">
                          <div class="wsp-width-30 wsp-text-align-right">系统盘(D盘)：</div>
                          <div :class="`wsp-width-60 `">
                            <el-input-number class="wsp-width-100" v-model="desktopItem.dDiskSize"></el-input-number>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="wsp-display-flex setting-attr wsp-margin-3">
                          <div class="wsp-width-30 wsp-text-align-right">桌面模式：</div>
                          <div :class="`wsp-width-60 ${desktopItem.desktopType ? '' : 'input-validate-not-null'}`">
                            <el-select class="wsp-width-100" v-model="desktopItem.desktopType" placeholder="请选择">
                              <el-option
                                v-for="(desktopTypeItem, index) in desktopTypeList"
                                :key="index"
                                :label="desktopTypeItem.label"
                                :value="desktopTypeItem.label"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="wsp-width-35 wsp-border-right softwar-content">
                    <div class="wsp-text-align-center wsp-border-bottom wsp-margin-3" v-if="systemIndex === 0">
                      <strong>软件信息</strong>
                    </div>
                    <div class="softwar-detail-content">
                      <div class="wsp-padding-3  wsp-display-flex wsp-display-flex-warp">
                        <div
                          v-for="(softItem, softIndex) in desktopItem.softwareList"
                          :key="softIndex"
                          :class="`softwar-item wsp-line-height-36`"
                          style="max-width: 100%;"
                        >
                          <div class="wsp-display-flex wsp-height-100">
                            <div
                              class="softwar-item-support wsp-text-align-center wsp-height-100"
                              @click="showSoftwareDetail(softItem)"
                            >
                              <div
                                class="support-item wsp-padding-lr-6 wsp-line-height-36  wsp-height-100 backgroud-color-3bb113"
                                v-if="softItem.compatibleStatus === 'SUPPORT'"
                              >
                                支持
                              </div>
                              <div
                                class="  support-item   wsp-padding-lr-6  wsp-line-height-36   wsp-height-100 backgroud-color-f13131"
                                v-else-if="softItem.compatibleStatus === 'NOT_SUPPORT'"
                              >
                                不支持
                              </div>
                              <div
                                class=" support-item wsp-padding-lr-6  font-size-12 wsp-line-height-36 wsp-height-100 backgroud-color-E69D01"
                                v-else
                              >
                                未知
                              </div>
                            </div>
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="`${softItem.softwareName} | ${softItem.softwareVersion}`"
                              placement="top"
                            >
                              <div
                                class="softwar-item-name wsp-padding-left-3"
                                style="margin-right: 40px;"
                                @click="showSoftwareDetail(softItem)"
                              >
                                <span>
                                  {{ softItem.softwareName }}
                                </span>
                                <span class="wsp-margin-tb-24 wsp-padding-lr-3">|</span>
                                <span>
                                  {{ softItem.softwareVersion }}
                                </span>
                              </div>
                            </el-tooltip>
                            <div class="softwar-item-btns">
                              <el-button
                                @click="removeSoftware(index, systemIndex, softIndex)"
                                type="text"
                                class="el-icon-close desktop-system-index-btn remove-btn"
                              ></el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="softwar-detail-toolbar">
                      <!-- <el-button
                        type="text"
                        @click="bindCollectSoftware(postDesktopItem, index, desktopItem, systemIndex)"
                        :disabled="!desktopItem.reportId"
                        >从报告中添加</el-button
                      > -->
                      <el-button type="text" @click="bindSoftware(postDesktopItem, index, desktopItem, systemIndex)"
                        >添加软件</el-button
                      >
                    </div>
                  </div>
                  <div class="wsp-width-30 softwar-content">
                    <div class="wsp-text-align-center wsp-border-bottom wsp-margin-3" v-if="systemIndex === 0">
                      <strong>外设信息</strong>
                    </div>

                    <div class="softwar-detail-content">
                      <div class="wsp-padding-3  wsp-display-flex wsp-display-flex-warp">
                        <div
                          v-for="(peripheralItem, peripheralIndex) in desktopItem.peripheralList"
                          :key="peripheralIndex"
                          :class="`softwar-item wsp-line-height-36`"
                          style="max-width: 100%;"
                        >
                          <div class="wsp-display-flex wsp-height-100">
                            <div
                              class="softwar-item-support wsp-text-align-center wsp-height-100"
                              @click="showPeripheralDetail(peripheralItem)"
                            >
                              <div
                                class="support-item wsp-padding-lr-6 wsp-line-height-36  wsp-height-100 backgroud-color-3bb113"
                                v-if="peripheralItem.compatibleStatus === 'SUPPORT'"
                              >
                                支持
                              </div>
                              <div
                                class="  support-item   wsp-padding-lr-6  wsp-line-height-36   wsp-height-100 backgroud-color-f13131"
                                v-else-if="peripheralItem.compatibleStatus === 'NOT_SUPPORT'"
                              >
                                不支持
                              </div>
                              <div
                                class=" support-item wsp-padding-lr-6  font-size-12 wsp-line-height-36 wsp-height-100 backgroud-color-E69D01"
                                v-else
                              >
                                未知
                              </div>
                            </div>
                            <el-tooltip class="item" effect="dark" :content="`${peripheralItem.name}`" placement="top">
                              <div
                                class="softwar-item-name wsp-padding-left-3"
                                style="margin-right: 40px;"
                                @click="showPeripheralDetail(peripheralItem)"
                              >
                                <span>
                                  {{ peripheralItem.name }}
                                </span>
                              </div>
                            </el-tooltip>

                            <div class="softwar-item-btns">
                              <el-button
                                @click="removePeripheral(index, systemIndex, peripheralIndex)"
                                type="text"
                                class="el-icon-close  desktop-system-index-btn remove-btn"
                              ></el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="softwar-detail-toolbar">
                      <!-- <el-button
                        type="text"
                        @click="bindCollectPeripheral(postDesktopItem, index, desktopItem, systemIndex)"
                        :disabled="!desktopItem.reportId"
                        >从报告中添加</el-button
                      > -->
                      <el-button type="text" @click="bindPeripheral(postDesktopItem, index, desktopItem, systemIndex)"
                        >添加外设</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scene-bottom"></div>
        </div>
      </div>
    </div>

    <el-drawer
      ref="drawer"
      :key="drawerKey"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="handleCloseDrawer"
      direction="rtl"
    >
      <div class="relation-page-group">
        <div class="wsp-group-title">
          <div class="wsp-group-title-icon"></div>
          <div class="wsp-group-title-value" v-if="showPageType === 'bindReport'">客户环境采集报告选择</div>
          <div class="wsp-group-title-value" v-if="showPageType === 'bindSoftware'">添加桌面所需的软件</div>
          <div class="wsp-group-title-value" v-if="showPageType === 'bindSpecPositionSoftware'">
            绑定采集报告中所需的软件
          </div>
          <div class="wsp-group-title-value" v-if="showPageType === 'bindPeripheral'">添加桌面所需的外设</div>
          <div class="wsp-group-title-value" v-if="showPageType === 'bindSpecPositionPeripheral'">
            添加采集报告中所需的外设
          </div>
          <div class="wsp-group-title-value" v-if="showPageType === 'addTemplatePosition'">新增模版岗位</div>
        </div>
      </div>
      <div v-if="showPageType === 'bindReport'">
        <el-row class="wsp-padding-top-18">
          <el-button style="margin-left: 13px;margin-bottom: 10px;" type="primary" @click="UploadReport"
            >导入报告</el-button
          >
          <el-button style="margin-left: 5px;margin-bottom: 10px;" type="primary" @click="ReportCreate"
            >手工添加客户环境信息</el-button
          >
        </el-row>
        <report-table :params="handelPostDesktop" @chagneSceneRelation="bindDesktopReport"></report-table>
      </div>

      <div v-if="showPageType === 'bindSoftware'">
        <el-tabs v-model="activeSoftware" @tab-click="activeSoftwareClick">
          <el-tab-pane label="从报告中添加" name="REPORT"
            ><collect-spec-soft-table
              :reportId="handelBindPostSystem.reportId"
              @addSelect="bindCollectReportSoftware"
              @removeBindReport="removeBindReport"
              @bindDesktopReport="bindDesktopReport"
            ></collect-spec-soft-table
          ></el-tab-pane>
          <el-tab-pane label="从系统推荐中添加" name="SYSTEM"
            ><software-table @addSelect="bindSystemSoftware"></software-table
          ></el-tab-pane>
          <el-tab-pane label="手动添加" name="HANDEL"
            ><collect-handel-spec-soft-table
              :customer="customer"
              :reportId="handelBindPostSystem.reportId"
              @removeBindReport="removeBindReport"
              @addSelect="bindCollectReportSoftware"
              @bindDesktopReport="bindDesktopReport"
            ></collect-handel-spec-soft-table
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="showPageType === 'bindPeripheral'">
        <el-tabs v-model="activePeripheral" @tab-click="activePeripheralClick">
          <el-tab-pane label="从报告中添加" name="REPORT">
            <collect-peripheral-table
              :reportId="handelBindPostSystem.reportId"
              @removeBindReport="removeBindReport"
              @addSelect="bindSelectCollectPeripheral"
              @bindDesktopReport="bindDesktopReport"
            ></collect-peripheral-table
          ></el-tab-pane>
          <el-tab-pane label="从系统推荐中添加" name="SYSTEM"
            ><peripheral-table @addSelect="bindSystemPeripheral"></peripheral-table>
          </el-tab-pane>
          <el-tab-pane label="手动添加" name="HANDEL">
            <collect-handel-peripheral-table
              :customer="customer"
              :reportId="handelBindPostSystem.reportId"
              @removeBindReport="removeBindReport"
              @addSelect="bindSelectCollectPeripheral"
              @bindDesktopReport="bindDesktopReport"
            ></collect-handel-peripheral-table
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="showPageType === 'bindSpecPositionPeripheral'">
        <collect-peripheral-table
          :reportId="handelBindPostSystem.reportId"
          @addSelect="bindSelectCollectPeripheral"
        ></collect-peripheral-table>
      </div>
      <div v-if="showPageType === 'addTemplatePosition'">
        <spec-position @chagneRelation="addTempPosition"></spec-position>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { InputNumber, Input, Select, Option, Tag, Button, Drawer, Tooltip, Tabs, TabPane } from 'element-ui'

import { extend } from 'sk-ui/lib/utils/util.js'

import dictionary from '../../../../../../utils/dictionary'
import CollectHandelPeripheralTable from '../../common/CollectHandelPeripheralTable'
import CollectHandelSpecSoftTable from '../../common/CollectHandelSpecSoftTable'
import collectPeripheralTable from '../../common/CollectPeripheralTable'
import collectSpecSoftTable from '../../common/CollectSpecSoftTable'
import PeripheralTable from '../../common/PeripheralTable'
import reportTable from '../../common/reportTable'
import softwareTable from '../../common/softwareTable'
import specPosition from '../../common/specPosition'

import { getPorjectPositionDetail, createProjectPosition } from '@/api/deliveryPosition'
import { getDetail } from '@/api/deliveryProject'

import { getAllOsType } from '@/api/osType'
import { getDesktopType } from '@/api/setting'
import reportCreateForm from '@/store/modules/pocMng/metaData/reportCreateForm'
import uploadCollectReport from '@/store/modules/pocMng/metaData/uploadCollectReport'

import { getCollectTool } from '@/utils/pageUtils'

export default {
  name: 'SkyDeployStepViewDesktopInfo',
  props: {
    projectId: {
      type: String
    },
    industryId: {
      type: String
    }
  },
  components: {
    [InputNumber.name]: InputNumber,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Tooltip.name]: Tooltip,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    reportTable,
    softwareTable,
    PeripheralTable,
    specPosition,
    collectSpecSoftTable,
    collectPeripheralTable,
    CollectHandelPeripheralTable,
    CollectHandelSpecSoftTable
  },
  created() {
    this.getInit()
    this.getProjectDetail()
    // this.getPositionDetail()
    this.$emit('showBtns', {
      preStep: true,
      nextStep: true,
      saveStep: false,
      enableTabChange: true,
      enableSkipNext: true
    })
  },
  mounted() {},
  data: function() {
    return {
      drawerKey: 0,
      dialogVisible: false,
      dictionary: dictionary,
      handelPostDesktop: null,
      handelBindPostIndex: null,
      handelBindPostSystem: null,
      downToolTip: `1、下载工具放到客户PC解压，点击WSPTool应用程序运行，输入基础信息后，点击开始采集<br>2、查看报告：查看PDF格式的报告<br>3、导出报告：离线环境下需要导出zip格式的包，然后手动上传到平台<br>4、上传报告：联网环境下点击后可自动上传到平台`,
      handelBindPostSystemIndex: null,
      showPageType: null,
      desktopTypeList: [],
      osTypeList: [],
      customer: null,
      projectDetail: {},
      postDesktopList: [],
      activeSoftware: 'REPORT',
      activePeripheral: 'REPORT'
    }
  },
  filters: {
    filterValueData(value) {
      var status = this.validateCompatibleStatus(value)
      if (status === 'SUPPORT') {
        return '支持'
      }
      if (status === 'NOT_SUPPORT') {
        return '不支持'
      }
      return '未知'
    },
    filterCodeData(value) {
      var status = this.validateCompatibleStatus(value)
      if (status) {
        return status
      }
      return '未知'
    }
  },
  methods: {
    downloadCollectTool() {
      getCollectTool()
    },
    activePeripheralClick(tab, event) {
      this.activePeripheral = tab.name
    },
    activeSoftwareClick(tab, event) {
      this.activeSoftware = tab.name
    },
    getProjectDetail() {
      getDetail({ id: this.projectId }).then(res => {
        this.projectDetail = res.data.content
        this.customer = this.projectDetail.customer
        this.getPositionDetail()
      })
    },
    getInit() {
      getDesktopType().then(res => {
        this.desktopTypeList = res.data.content.itemArr
      })
      getAllOsType().then(res => {
        this.osTypeList = res.data.content.itemArr
      })
    },
    getPositionDetail() {
      getPorjectPositionDetail({ id: this.projectId }).then(res => {
        this.postDesktopList = res.data.content
        this.changeInitCompa()
      })
    },
    changeInitCompa() {
      for (const position of this.postDesktopList) {
        for (const desktop of position.desktopList) {
          // 处理软件
          for (const softare of desktop.softwareList) {
            var status = this.validateCompatibleStatus(softare.compat)
            softare.compatibleStatus = status
          }
          // 处理外设
          for (const peripheral of desktop.peripheralList) {
            var statusPer = this.validateCompatibleStatus(peripheral.compat)
            peripheral.compatibleStatus = statusPer
          }
        }
      }
    },
    getData() {
      for (const element of this.postDesktopList) {
        element.projectId = this.projectId
      }
      return this.postDesktopList
    },
    async gotoNextStep() {
      this.message = '点击了下一步'
      var data = this.getData()
      var result = false
      await createProjectPosition({ positionList: data, projectId: this.projectId })
        .then(res => {
          result = true
        })
        .catch(e => {
          result = false
        })
      return result
    },
    removePosition(index) {
      this.postDesktopList.splice(index, 1)
    },
    bindPeripheral(postDesktop, postIndex, desktopItem, systemIndex) {
      this.showPageType = 'bindPeripheral'
      this.handelPostDesktop = postDesktop
      this.handelPostDesktop.projectId = this.projectId
      this.handelBindPostIndex = postIndex
      this.handelBindPostSystem = desktopItem
      this.handelBindPostSystemIndex = systemIndex

      this.dialogVisible = true
      this.drawerKey++
    },
    bindCollectPeripheral(postDesktop, postIndex, desktopItem, systemIndex) {
      this.showPageType = 'bindSpecPositionPeripheral'
      this.handelPostDesktop = postDesktop
      this.handelPostDesktop.projectId = this.projectId
      this.handelBindPostIndex = postIndex
      this.handelBindPostSystem = desktopItem
      this.handelBindPostSystemIndex = systemIndex

      this.dialogVisible = true
      this.drawerKey++
    },
    bindSoftware(postDesktop, postIndex, desktopItem, systemIndex) {
      this.showPageType = 'bindSoftware'
      this.handelPostDesktop = postDesktop
      this.handelPostDesktop.projectId = this.projectId
      this.handelBindPostIndex = postIndex
      this.handelBindPostSystem = desktopItem
      this.handelBindPostSystemIndex = systemIndex

      this.dialogVisible = true
      this.drawerKey++
    },
    bindCollectSoftware(postDesktop, postIndex, desktopItem, systemIndex) {
      this.showPageType = 'bindSpecPositionSoftware'
      this.handelPostDesktop = postDesktop
      this.handelPostDesktop.projectId = this.projectId
      this.handelBindPostIndex = postIndex
      this.handelBindPostSystem = desktopItem
      this.handelBindPostSystemIndex = systemIndex

      this.dialogVisible = true
      this.drawerKey++
    },
    removeBindReport(report) {
      var desktop = this.postDesktopList[this.handelBindPostIndex].desktopList[this.handelBindPostSystemIndex]
      this.$set(desktop, 'reportDetail', null)
      this.$set(desktop, 'reportId', null)
      var softwareList = []
      for (const element of desktop.softwareList) {
        if (element.sourceFrom !== 'CUSTOMER_ENV') {
          softwareList.push(element)
        }
      }
      this.$set(desktop, 'softwareList', softwareList)

      var peripheralList = []
      for (const peripheral of desktop.peripheralList) {
        if (peripheral.sourceFrom !== 'CUSTOMER_ENV') {
          peripheralList.push(peripheral)
        }
      }
      this.$set(desktop, 'peripheralList', peripheralList)
    },
    bindReport(postDesktop, index, desktopItem, desktopIndex) {
      this.showPageType = 'bindReport'
      this.dialogVisible = true
      this.drawerKey++
      this.handelPostDesktop = postDesktop
      this.handelPostDesktop.projectId = this.projectId
      this.handelBindPostSystem = desktopItem
      this.handelBindPostSystemIndex = desktopIndex
      this.handelBindPostIndex = index
    },
    bindDesktopReport(bindReport) {
      var desktop = this.postDesktopList[this.handelBindPostIndex].desktopList[this.handelBindPostSystemIndex]
      this.$set(desktop, 'reportDetail', bindReport.select)
      this.$set(desktop, 'reportId', bindReport.select.id)
    },
    validateCompatibleStatus(compat) {
      var result = null
      if (!compat) {
        return result
      }

      for (const element of compat) {
        // 暂时只有一个，特殊处理
        var productVersion = this.projectDetail.productVersionList[0]
        if (productVersion.approvalTime > element.approvalTime) {
          if (element.compatibleStatus === 'SUPPORT' || element.compatibleStatus == 'LIMITED_SUPPORT') {
            result = 'SUPPORT'
          } else {
            result = 'NOT_SUPPORT'
          }
          break
        }
      }
      return result
    },
    bindSelectCollectPeripheral(selectCollectSoft) {
      var system = this.postDesktopList[this.handelBindPostIndex].desktopList[this.handelBindPostSystemIndex]

      if (!system.peripheralList) {
        system.peripheralList = []
      }
      for (const element of selectCollectSoft.select) {
        var status = this.validateCompatibleStatus(element.compat)
        var peripheral = {
          sourceFrom: 'CUSTOMER_ENV',
          name: element.name,
          compatibleStatus: status,
          compat: element.compat,
          peripheralId: element.id
        }
        system.peripheralList.push(peripheral)
      }
      this.$set(system, 'peripheralList', system.peripheralList)
      this.handleCloseDrawer()
    },
    bindSystemSoftware(selectSoftware) {
      var system = this.postDesktopList[this.handelBindPostIndex].desktopList[this.handelBindPostSystemIndex]
      for (const element of selectSoftware.select) {
        const exists = system.softwareList.some(obj => obj.softwareId === element.id)
        if (!exists) {
          var status = this.validateCompatibleStatus(element.compat)

          var soft = {
            sourceFrom: 'MANUALLY_ADD',
            softwareName: element.softwareName,
            softwareVersion: element.softwareVersion,
            compat: element.compat,
            compatibleStatus: status,
            softwareId: element.id,
            specSoftwareId: element.id
          }
          system.softwareList.push(soft)
        }
      }

      this.$set(system, 'softwareList', system.softwareList)
      this.handleCloseDrawer()
    },
    removeSoftware(positionIndex, systemIndex, softwareIndex) {
      var system = this.postDesktopList[positionIndex].desktopList[systemIndex]
      system.softwareList.splice(softwareIndex, 1)
      this.$set(system, 'softwareList', system.softwareList)
    },
    removePeripheral(positionIndex, systemIndex, peripherialIndex) {
      var system = this.postDesktopList[positionIndex].desktopList[systemIndex]
      system.peripheralList.splice(peripherialIndex, 1)
      this.$set(system, 'peripheralList', system.peripheralList)
    },

    bindSystemPeripheral(selectPeripheral) {
      var system = this.postDesktopList[this.handelBindPostIndex].desktopList[this.handelBindPostSystemIndex]
      for (const element of selectPeripheral.select) {
        const exists = system.peripheralList.some(obj => obj.peripheralId === element.id)
        if (!exists) {
          var status = this.validateCompatibleStatus(element.compat)
          var peripheral = {
            sourceFrom: 'MANUALLY_ADD',
            name: element.name,
            compat: element.compat,
            compatibleStatus: status,
            peripheralId: element.id,
            specPeripheralId: element.id
          }
          system.peripheralList.push(peripheral)
        }
      }
      this.$set(system, 'peripheralList', system.peripheralList)
      this.handleCloseDrawer()
    },
    showSoftwareDetail(softItem) {
      if (softItem.sourceFrom === 'MANUALLY_ADD') {
        this.$store.dispatch('ShowSoftwareDetail', { id: softItem.specSoftwareId, softwareName: softItem.softwareName })
      } else if (softItem.sourceFrom === 'CUSTOMER_ENV') {
        this.$store.dispatch('ShowCollectSoftwareDetail', {
          id: softItem.softwareId,
          softwareName: softItem.softwareName
        })
      } else if (softItem.sourceFrom === 'TEMPLATE') {
        this.$store.dispatch('ShowSoftwareDetail', { id: softItem.specSoftwareId, softwareName: softItem.softwareName })
      }
    },
    showPeripheralDetail(item) {
      if (item.sourceFrom === 'MANUALLY_ADD') {
        this.$store.dispatch('ShowPeripheralDetail', {
          id: item.specPeripheralId,
          name: item.name
        })
      } else if (item.sourceFrom === 'CUSTOMER_ENV') {
        this.$store.dispatch('ShowCollectPeripheralDetail', {
          id: item.peripheralId,
          name: item.name
        })
      } else if (item.sourceFrom === 'TEMPLATE') {
        this.$store.dispatch('ShowPeripheralDetail', {
          id: item.specPeripheralId,
          name: item.name
        })
      }
    },
    showPeripheralRelationDetail(peripheralItem) {
      this.$store.dispatch('ShowPeripheralRelationDetail', peripheralItem)
    },
    bindCollectReportSoftware(selectParams) {
      var system = this.postDesktopList[this.handelBindPostIndex].desktopList[this.handelBindPostSystemIndex]
      if (!system.softwareList) {
        system.softwareList = []
      }
      for (const element of selectParams.select) {
        var status = this.validateCompatibleStatus(element.compat)
        var soft = {
          sourceFrom: 'CUSTOMER_ENV',
          softwareName: element.softwareName,
          compatibleStatus: status,
          softwareVersion: element.softwareVersion,
          compat: element.compat,
          softwareId: element.id
        }
        system.softwareList.push(soft)
      }
      this.$set(system, 'softwareList', system.softwareList)
      this.handleCloseDrawer()
    },
    addPostByTemplate() {
      this.showPageType = 'addTemplatePosition'
      this.dialogVisible = true
      this.drawerKey++
    },
    addTempPosition(params) {
      for (const element of params.select) {
        var defaultPostInfo = {
          sourceFrom: 'TEMPLATE',
          name: element.positionName,
          description: element.positionDesc,
          specPositionId: element.id,
          desktopList: []
        }

        if (element.positionDesktop) {
          var position = {
            sourceFrom: 'TEMPLATE',
            desktopNum: 1,
            osTypeId: element.positionDesktop.osTypeId,
            cpuCore: element.positionDesktop.cpuCore,
            memory: element.positionDesktop.memory,
            cDiskSize: element.positionDesktop.cDiskSize,
            dDiskSize: element.positionDesktop.dDiskSize,
            desktopType: element.positionDesktop.desktopType,
            softwareList: [],
            peripheralList: []
          }
          for (const softItem of element.positionSoftwareList) {
            var status = this.validateCompatibleStatus(softItem.compat)
            var soft = {
              sourceFrom: 'TEMPLATE',
              softwareName: softItem.softwareName,
              compatibleStatus: status,
              softwareVersion: softItem.softwareVersion,
              compat: softItem.compat,
              specSoftwareId: softItem.specId,
              softwareId: softItem.id
            }
            position.softwareList.push(soft)
          }

          for (const peripheralItem of element.positionPeripheralList) {
            var statusx = this.validateCompatibleStatus(peripheralItem.compat)
            var peripheral = {
              sourceFrom: 'TEMPLATE',
              name: peripheralItem.name,
              compatibleStatus: statusx,
              compat: peripheralItem.compat,
              specPeripheralId: peripheralItem.specId,
              peripheralId: peripheralItem.id
            }
            position.peripheralList.push(peripheral)
          }

          defaultPostInfo.desktopList.splice(0, 0, position)
        } else {
          var positiona = {
            osTypeId: null,
            memory: 0,
            cpuCore: 0,
            cDiskSize: 0,
            dDiskSize: 0,
            desktopType: 0,
            softwareList: [],
            peripheralList: []
          }
          defaultPostInfo.desktopList.push(positiona)
        }
        this.postDesktopList.splice(0, 0, defaultPostInfo)
      }
      this.handleCloseDrawer()
    },
    addPostitionDesktop(positionIndex) {
      var desktop = {
        osTypeId: null,
        sourceFrom: 'MANUALLY_ADD',
        cpuFrequency: null,
        disk_cont: 0,
        memory: 0,
        cDiskSize: 0,
        dDiskSize: 0,
        desktopType: null,
        softwareList: [],
        peripheralList: []
      }
      var position = this.postDesktopList[positionIndex]
      position.desktopList.push(desktop)
      this.postDesktopList.splice(positionIndex, 1, position)
    },
    removePositionDesktop(positionIndex, systemIndex) {
      var position = this.postDesktopList[positionIndex]
      position.desktopList.splice(systemIndex, 1)
    },
    addPostByHandel() {
      var defaultPostInfo = {
        sourceFrom: 'MANUALLY_ADD',
        name: null,
        description: null,
        desktopList: [
          {
            osTypeId: null,
            sourceFrom: 'MANUALLY_ADD',
            cpuFrequency: '',
            desktopNum: 1,
            disk_cont: 0,
            memory: 0,
            cDiskSize: 0,
            dDiskSize: 0,
            desktopType: null,
            softwareList: [],
            peripheralList: []
          }
        ]
      }

      this.postDesktopList.splice(0, 0, defaultPostInfo)
    },
    UploadReport({ commit }, params) {
      const uploadCollectReportCopy = extend(true, {}, uploadCollectReport)
      var props = {
        params: {}
      }
      this.$store.dispatch('OpenFullDialog', { metaData: uploadCollectReportCopy, props, clone: false })
    },
    ReportCreate({ commit }, params) {
      const props = {
        'view.content[$id=customer].$el': { disabled: true },
        'view.content[$id=customer].$default': this.customer,
        'view.showOkBtn': false,
        'view.showCancelBtn': false,
        toolbar: {
          items: [
            {
              slot: 'refresh-rigtht',
              label: 'confirm',
              props: {
                type: 'primary',
                disabled: false
              },
              action: 'AfterReportCreate'
            },
            {
              slot: 'refresh-rigtht',
              label: 'cancel',
              action: 'ReturnPage'
            }
          ]
        },
        extraParams: {
          collectView: this
        }
      }
      this.$store.dispatch('OpenFullDialog', {
        metaData: reportCreateForm,
        props
      })
    },
    handleCloseDrawer() {
      this.handelBindReport = null
      this.handelBindPostIndex = null
      this.showPageType = null
      this.dialogVisible = false
    },
    async gotoNextPreVliate() {
      var result = true
      for (const element of this.postDesktopList) {
        if (!element.name) {
          result = false
          break
        }
        for (const desktop of element.desktopList) {
          if (!desktop.cpuCore || !desktop.memory || !desktop.cDiskSize || !desktop.desktopType) {
            result = false
            break
          }
        }
        if (!result) {
          break
        }
      }

      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '还有必填项未填写，请检查！', type: 'error' })
      }
      return result
    },
    async gotoPreStep() {
      this.message = '点击了上一步'
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(deploy-step-view-desktop-info) {
  .desktop-info-item-content {
    overflow-y: auto;
    height: 70vh;
    .desktop-info-item {
      position: relative;
      .desktop-info-item-toolbar {
        position: absolute;
        left: 0px;
        top: 3px;
        z-index: 9;
        font-size: 16px;
        .remove-btn {
          display: none;
        }
        .remove-btn .el-button--text {
          color: #f13131 !important;
        }
      }
    }
    .desktop-info-item:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
      background: rgba(0, 82, 217, 0.0389);
      border-color: #0052d9 !important;
    }
    .desktop-info-item:hover .remove-btn {
      display: block;
    }
    .desktop-post-content {
      position: relative;
      .position-item-arr input {
        border: none;
      }
      .position-item-arr .item-label {
        padding: 0 12px;
      }
      .desktop-post-toolbar {
        position: absolute;
        bottom: 0%;
        width: 100%;
        text-align: center;
      }
    }
    .desktop-system-index {
      position: relative;
      .desktop-system-index-value {
        position: absolute;
        height: 85%;
        width: 100%;
        font-size: 16px;
        .report-name {
          font-size: 12px;
        }
      }
      .desktop-system-index-btn {
        position: absolute;
        bottom: 6px;
        z-index: 12;
      }
    }
    .softwar-content {
      position: relative;
      .softwar-detail-content {
        height: 180px;
        overflow-y: auto;
        .softwar-item {
          border: 0.5px solid #ccc;
          border-radius: 25px;
          margin: 2px;
          height: 36px;
          width: 49%;
          position: relative;
          .softwar-item-name {
            display: flex; /* 使用 Flexbox 布局 */
            align-items: center; /* 垂直居中对齐 */
            overflow: hidden; /* 隐藏超出部分 */
            white-space: nowrap; /* 不换行 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
            box-sizing: border-box;
          }
          .softwar-item-support {
            .support-item {
              // border-radius: 25px;
              width: 60px;
              color: #fff;
              border-top-left-radius: 25px;
              border-bottom-left-radius: 25px;
            }
          }
          .softwar-item-btns {
            position: absolute;
            right: 0;
          }
        }
      }
      .softwar-detail-toolbar {
        position: absolute;
        bottom: 0%;
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
